// Commercial Accounts — 8-step progress indicator (state is shown by icon AND text, never colour alone).
import { Check, X, Minus } from "lucide-react";

const WORD = { done: "done", current: "current step", todo: "not yet reached", stopped: "stopped here", skipped: "not recorded" };

function Dot({ state }) {
  if (state === "done") return <span className="w-4 h-4 rounded-full bg-[#0e6b52] text-white grid place-items-center"><Check size={11} strokeWidth={3} /></span>;
  if (state === "current") return <span className="w-4 h-4 rounded-full bg-[#16a34a] ring-2 ring-[#bbf7d0]" />;
  if (state === "stopped") return <span className="w-4 h-4 rounded-full bg-[#b91c1c] text-white grid place-items-center"><X size={11} strokeWidth={3} /></span>;
  if (state === "skipped") return <span className="w-4 h-4 grid place-items-center text-[#9ca3af]"><Minus size={11} /></span>;
  return <span className="w-2 h-2 m-1 rounded-full bg-[#d1d5db]" />;
}

export function StepIndicator({ progress, compact = false, testId = "step-indicator" }) {
  if (!progress) return null;
  return (
    <div className={`flex ${compact ? "items-center gap-3" : "flex-col gap-2"}`} data-testid={testId}>
      <ol className="flex items-center gap-1" aria-label="Application progress">
        {progress.steps.map((s) => (
          <li key={s.n} className="flex items-center gap-1" title={`${s.n} ${s.label}: ${WORD[s.state]}`} aria-label={`${s.n} ${s.label}: ${WORD[s.state]}`} data-testid={`${testId}-step-${s.n}`} data-state={s.state}>
            <Dot state={s.state} />
            {!compact && <span className={`text-xs mr-2 ${s.state === "current" || s.state === "stopped" ? "font-semibold text-[#0e1420]" : "text-[#6b7280]"}`}>{s.n} {s.label}</span>}
          </li>
        ))}
      </ol>
      <span className={`text-xs ${progress.end_state ? "text-[#b91c1c] font-semibold" : "text-[#374151]"}`} data-testid={`${testId}-label`}>
        {progress.end_state ? "Ended: " : `Step ${progress.current} of 8 · `}{progress.label}
      </span>
    </div>
  );
}

export function ApprovedBadge({ terms, date, by, testId = "approved-badge" }) {
  if (!terms) return null;
  return (
    <span className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded bg-[#e7f6ef] text-[#0e6b52] font-semibold" data-testid={testId}>
      <Check size={11} strokeWidth={3} />Approved Net {terms}{date ? ` · ${String(date).slice(0, 10)}` : ""}{by ? ` · ${by}` : ""}
    </span>
  );
}
